module.exports = __webpack_public_path__ + "img/serveLogo2.332c1f85.png";